export function selectionItemsApp(): void {
  if (document.getElementById('selection-item-app')) {
    // eslint-disable-next-line no-unused-expressions
    import(
      /* webpackChunkName: "selection-item-app" */ '@organisms/offer/selection-items/main'
    );
  }
}
